import React from 'react';
import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import ViewItems from '../../components/ViewItems';
import ViewReverse from '../../components/ViewReverse';
import CustomDropdown from '../../components/CustomDropdown';
import { monthsOptions, years } from '../../config/config';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import Button from '../../components/Button';
import { rowReverseStylemd, rowReverseStylesm } from '../../utils/styles';
import investmentReportFunctional from './index.function';
import { Formik } from 'formik';
import { investment_report_schema, investment_report_validation_schema } from '../../validations_schemas/investment_report_validation_schema';
import ErrorText from '../../components/ErrorText';
import TermsModal from '../../components/TermsModal';
import { downloadBase64File } from '../../utils/functions';
import images from '../../constants/images';

const InvestmentReport = () => {
  const {
    isArabic,
    TextWeight,
    investmentDropdown,
    getContentKey,
    onPressSubmit,
    settingLoading,
    investmentReport,
    termsModal,
    setTermsModal,
    onPressEmail,
  } = investmentReportFunctional();

  return (
    <div>
      <Text
        text={getContentKey('reports')}
        size={fontSizes.h24}
        weight={TextWeight.bold}
        color='text-primary'
      />
      <Formik
        validationSchema={investment_report_validation_schema}
        initialValues={investment_report_schema}
        onSubmit={(values) => onPressSubmit(values)}
        validateOnBlur={false}
        validateOnChange={false}
      >
        {({ handleSubmit, setFieldValue, values, resetForm, setFieldError, errors }) => {
          const isValid = values?.asset_class && values.product && values.month && values.year && values.report_type;

          return (
            <ViewItems>
              <ViewReverse
                className={`border border-grey px-5 py-3 rounded flex-col w-full mt-5 gap-4 justify-between pb-32 ${rowReverseStylemd(isArabic)}`}
              >
                <ViewItems className={'w-full justify-between'}>
                  <div className='w-full'>
                    <Text
                      text={getContentKey('investment_reports')}
                      size={fontSizes.h14}
                      className={'mb-3'}
                    />
                    <ViewReverse className={`gap-4 flex-col ${rowReverseStylesm(isArabic)}`}>
                      <div className='w-full'>
                        <CustomDropdown
                          label={getContentKey('asset_class')}
                          selectedValue={values?.asset_class}
                          onSelect={(val) => {
                            setFieldValue('asset_class', val);
                          }}
                          options={investmentDropdown?.assetClasses}
                          isBorder
                          isError={errors?.asset_class}
                        />
                        <ErrorText
                          text={errors?.asset_class}
                          getContentKey={getContentKey}
                        />
                      </div>
                      <div className='w-full'>
                        <CustomDropdown
                          label={getContentKey('product')}
                          selectedValue={values?.product}
                          onSelect={(val) => setFieldValue('product', val)}
                          options={investmentDropdown?.products}
                          isBorder
                          isError={errors?.product}
                        />
                        <ErrorText
                          text={errors?.product}
                          getContentKey={getContentKey}
                        />
                      </div>
                    </ViewReverse>

                    <ViewReverse className={`gap-4 mt-4 flex-col ${rowReverseStylesm(isArabic)}`}>
                      <div className='w-full'>
                        <CustomDropdown
                          label={getContentKey('select_month')}
                          onSelect={(val) => {
                            setFieldValue('month', val);
                          }}
                          options={monthsOptions(getContentKey)}
                          selectedValue={values?.month}
                          valueKey={'label'}
                          isError={errors?.month}
                        />
                        <ErrorText
                          text={errors?.month}
                          getContentKey={getContentKey}
                        />
                      </div>
                      <div className='w-full'>
                        <CustomDropdown
                          label={getContentKey('select_year')}
                          onSelect={(val) => {
                            setFieldValue('year', val);
                          }}
                          options={years}
                          selectedValue={values?.year}
                          valueKey={'year'}
                          isError={errors?.year}
                        />
                        <ErrorText
                          text={errors?.year}
                          getContentKey={getContentKey}
                        />
                      </div>
                    </ViewReverse>
                    <div className='w-full mt-4'>
                      <CustomDropdown
                        label={getContentKey('report_type')}
                        onSelect={(val) => {
                          setFieldValue('report_type', val);
                        }}
                        options={investmentDropdown?.reportTypes}
                        selectedValue={values?.report_type}
                        valueKey={'name'}
                        isError={errors?.report_type}
                      />
                      <ErrorText
                        text={errors?.year}
                        getContentKey={getContentKey}
                      />
                    </div>
                  </div>

                  <ViewReverse className={`w-full flex flex-col justify-between mt-4 sm:items-center gap-4 ${rowReverseStylesm(isArabic)}`}>
                    <Button
                      text={getContentKey('submit')}
                      className={'px-8'}
                      onClick={handleSubmit}
                      loading={settingLoading}
                      isDisabled={!isValid}
                    />
                    <ViewReverse>
                      <Text
                        text={getContentKey('view')}
                        size={fontSizes.h14}
                        color='text-primary'
                        className={'cursor-pointer'}
                        onClick={() => setTermsModal(true)}
                        isDisabled={!investmentReport?.report}
                      />
                      <div className='h-5 w-[1.5px] bg-primary mx-2' />
                      <Text
                        text={getContentKey('download')}
                        size={fontSizes.h14}
                        color='text-primary'
                        isDisabled={!investmentReport?.report}
                        onClick={() =>
                          downloadBase64File({
                            base64Data: investmentReport?.report,
                            fileName: investmentReport?.displayName,
                          })
                        }
                      />
                      <div className='h-5 w-[1.5px] bg-primary mx-2' />
                      <Text
                        text={getContentKey('email')}
                        size={fontSizes.h14}
                        color='text-primary'
                        onClick={onPressEmail}
                        className={'cursor-pointer'}
                        isDisabled={!investmentReport?.report}
                      />
                    </ViewReverse>
                  </ViewReverse>
                </ViewItems>

                <ViewItems className={'w-full sm:w-1/2 items-center gap-3'}>
                  {investmentReport?.report ? (
                    <img
                      src={images.report}
                      className='w-56'
                    />
                  ) : (
                    <div className='w-full mt-4 sm:me-4 flex justify-center items-center bg-light-grey p-10 rounded'>
                      <ReactSVG src={icons.pdf} />
                    </div>
                  )}
                  <Text
                    text={investmentReport?.displayName}
                    className={''}
                  />
                </ViewItems>
              </ViewReverse>
            </ViewItems>
          );
        }}
      </Formik>

      <TermsModal
        isOpen={termsModal}
        onClose={() => setTermsModal(false)}
        src={investmentReport?.report}
        title={investmentReport?.displayName}
      />
    </div>
  );
};

export default InvestmentReport;
